import { render, staticRenderFns } from "./mind.vue?vue&type=template&id=331464c8&scoped=true&"
import script from "./mind.vue?vue&type=script&lang=js&"
export * from "./mind.vue?vue&type=script&lang=js&"
import style0 from "./mind.vue?vue&type=style&index=0&id=331464c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331464c8",
  null
  
)

export default component.exports